<template>
  <div>
    <div v-if="imageStatus">
      <cropper
        :src="image.src"
        @change="change"
        :stencil-props="{
          handlers: {},
          movable: false,
          scalable: false,
          minAspectRatio: 16 / 8,
          maxAspectRatio: 1 / 1,
        }"
        :stencil-size="cropSize"
        :canvas="{
          imageSmoothingEnabled: 'true',
          imageSmoothingQuality: 'medium',
          maxWidth: 1024,
          maxHeight: 850,
        }"
        :stencil-component="cropShape"
        image-restriction="stencil"
        class="cropper d-block mx-auto"
      />
      <slot></slot>
    </div>
    <div v-if="!imageStatus" class="upload-photo-icon d-flex mx-auto justify-content-center align-items-center" @click="$refs.fileInput.click()">
      <div>
        <i class="fas fa-cloud-upload-alt icon-size"></i>
        <div class="upload-text-size">{{ title }}</div>
        <div class="upload-second-title">{{ secondTitle }}</div>
      </div>
    </div>
    <div v-if="imageStatus" class="d-flex justify-content-end align-items-center mt-3">
      <button @click="reset" class="reset-btn">{{ changeImageBtnText }}</button>
      <Button @click.native="uploadImage" :loading="cropperLoading" text="آپلود عکس" v-if="hasUploadButton" btnClass="upload-btn btn-border" />
    </div>
    <input style="display: none" type="file" accept="image/*" @change="onFileSelected" ref="fileInput" />
  </div>
</template>

<script>
import { Cropper } from 'vue-advanced-cropper'
import 'vue-advanced-cropper/dist/style.css'
import Button from '../../components/common/Button.vue'
export default {
  components: {
    Cropper,
    Button,
  },
  props: {
    img: {
      default: '',
    },
    title: {
      default: 'برای آپلود عکس خود کلیک کنید',
    },
    secondTitle: {
      default: '',
    },
    hasUploadButton: {
      default: true,
    },
    changeImageBtnText: {
      default: 'تلاش مجدد',
    },
    cropperLoading: {
      type: Boolean,
      default: false,
    },
    cropShape: {
      type: String,
      default: 'circle-stencil',
    },
    cropSize: {
      type: Object,
      default: () => ({
        width: 200,
        height: 200,
      }),
    },
  },
  data() {
    return {
      selectedFile: '',
      imageStatus: false,
      image: {
        src: null,
      },
      imageUrl: null,
    }
  },
  methods: {
    onFileSelected(event) {
      this.imageStatus = true
      this.selectedFile = event.target.files[0]
      this.image.src = URL.createObjectURL(this.selectedFile)
    },
    uploadImage() {
      this.$emit('imageSourceChanged', this.imageUrl)
    },
    change({ canvas }) {
      this.imageUrl = canvas.toDataURL()
      // this.$emit('imageSourceChanged', dataUrl)
      //
    },
    reset() {
      this.image.src = null
      this.imageStatus = false
      this.selectedFile = ''
    },
    // flip(x, y) {
    //   this.$refs.cropper.flip(x, y)
    // },
    // rotate(angle) {
    //   this.$refs.cropper.rotate(angle)
    // },
  },
}
</script>

<style scoped lang="scss">
.cropper {
  height: 400px;
  overflow: hidden;
  width: 600px;
}
::v-deep .vue-line-wrapper--north,
::v-deep .vue-line-wrapper--south,
::v-deep .vue-line-wrapper--east,
::v-deep .vue-line-wrapper--west {
  width: 0;
  height: 0;
}
.upload-photo-icon {
  height: 250px;
  width: 100%;
  border: 2px dashed #ced4da;
  border-radius: 8px;
}
.upload-text-size {
  font-size: 20px;
  text-align: center;
  margin-top: 10px;
  color: #495057;
}

.upload-second-title {
  font-size: 14px;
  text-align: center;
  margin-top: 10px;
  color: #495057;
}
.icon-size {
  font-size: 45px;
  text-align: center;
  display: block;
  color: #74788d;
}
.upload-btn {
  margin-right: 10px !important;
  background: #556ee6 !important;
  border-radius: 4px !important;
  color: white !important;
  padding: 8px 28px !important;
}
.reset-btn {
  display: block !important;
  background: white !important;
  border: 1px solid #556ee6 !important;
  border-radius: 4px !important;
  color: #556ee6 !important;
  padding: 8px 28px !important;
}
</style>
